"use client";
import { useParams, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const ScrollToTop = () => {
  const params = useParams();
  const searchParams = useSearchParams();

  useEffect(() => {
    const grid = document.getElementById("products-grid");
    if (grid) {
      const offset = 120; // Room for the fixed header
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = grid.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }, [params.id, searchParams.toString()]);

  return null;
};
